import { Typography } from 'antd';
import styled from 'styled-components';

interface StyledTitleProps {
  margin?: string;
  color?: string;
  fontWeight?: string;
  fontSize?: string;
}

export const StyledTitle = styled(Typography.Title)<StyledTitleProps>`
  margin: ${(props) => (props.margin ? `${props.margin}` : `0`)} !important;
  ${(props) => props.color && `color: ${props.color} !important;`}
  ${(props) => props.fontWeight && `font-weight: ${props.fontWeight} !important;`}
  ${(props) => props.fontSize && `font-size: ${props.fontSize} !important;`}
`;
